<mat-toolbar
  fxLayout="row"
  fxLayoutAlign="space-between center"
  class="!bg-transparent"
>
  <pr-principle-logo />
  <pr-toolbar-dropdown />
</mat-toolbar>
<div class="flex items-center justify-center pt-8">
  <div class="flex w-[560px] flex-col gap-4 rounded-lg bg-white p-8 shadow-lg">
    <div class="flex items-center justify-center gap-4 pb-2">
      @if (appIconUrl$ | async; as appIconUrl) {
        <div
          class="h-24 w-24 overflow-hidden rounded-md bg-cover bg-center"
          [ngStyle]="{
            'background-image': 'url(' + appIconUrl + ')'
          }"
        ></div>
      } @else {
        <div
          class="bg-primary-500 flex h-24 w-24 items-center justify-center rounded-md"
        >
          <mat-icon class="default-client text-white">webhook</mat-icon>
        </div>
      }

      <mat-icon class="compare-arrow">compare_arrows</mat-icon>
      <img
        src="assets/ico/apple-touch-icon-144x144.png"
        alt="Principle Logo"
        class="h-24 w-24 rounded-md"
      />
    </div>

    <div class="flex flex-col items-center">
      <h2 class="!mb-0">
        <span class="text-primary-500">{{ appName$ | async }}</span> is
        requesting access to your Principle Account
      </h2>
      <pr-auth-user-card [user]="user$ | async" />
    </div>

    <div class="flex flex-col gap-2">
      <strong>{{ appName$ | async }} is requesting access to:</strong>
      <div class="flex flex-col gap-2">
        @for (scope of scopeDescriptions; track scope) {
          <div class="flex items-center gap-4 rounded-md bg-gray-100 p-2">
            <mat-icon class="text-primary-500">check</mat-icon>
            <div>{{ scope }}</div>
          </div>
        }
      </div>
    </div>

    @if (practices$ | async; as practices) {
      @if (practices.length > 1) {
        <div class="flex flex-col gap-2">
          <strong>Allowed for the following practices:</strong>
          <div class="flex flex-col gap-2">
            @for (practice of practices; track practice.ref.path) {
              <div class="flex items-center gap-4 rounded-md bg-gray-100 p-2">
                <mat-checkbox
                  color="primary"
                  [checked]="
                    practice
                      | map: selectionList.isSelected$ : selectionList
                      | async
                  "
                  (change)="selectionList.toggleSelected(practice)"
                  >{{ practice.name }}</mat-checkbox
                >
              </div>
            }
          </div>
        </div>
      }
    }

    <pt-buttons-container padding="none">
      <button mat-stroked-button (click)="deny()">Deny</button>
      <button mat-flat-button color="primary" (click)="allow()">Allow</button>
    </pt-buttons-container>
  </div>
</div>
